export default __webpack_public_path__ + "static/media/349.9a8c3632.png";